<template>
    <div class="lo content">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .lo.content {
        
    }
</style>
